export enum ScreenElements {
  Exit = 'exit',
  Wall = 'wall',
  Emergency = 'emergency',
  Stairs = 'stairs',
  Rails = 'rails',
}
